(function() {
    const wrapper = document.querySelector('.slider-wrapper');
    const nextBtn = document.querySelector('.next-btn');
    const prevBtn = document.querySelector('.prev-btn');
    let cards = document.querySelectorAll('.review-card');

    if (!wrapper || !nextBtn || !prevBtn || cards.length === 0) return; // safety check

    let cardWidth = cards[0].offsetWidth + 20; // margin gap
    let currentIndex = 0;
    const visibleCards = 3;
    let scrollPosition = 0;

    let maxIndex = Math.ceil(cards.length / visibleCards) - 1;

    function updateButtons() {
        prevBtn.disabled = currentIndex === 0;
        nextBtn.disabled = currentIndex === maxIndex;
        prevBtn.classList.toggle('disabled', prevBtn.disabled);
        nextBtn.classList.toggle('disabled', nextBtn.disabled);
    }

    function updateSliderWidth() {
        cardWidth = cards[0].offsetWidth + 20;
        wrapper.style.width = `${cards.length * cardWidth}px`;
        scrollPosition = -(cardWidth * currentIndex * visibleCards);
        wrapper.style.transform = `translateX(${scrollPosition}px)`;
        updateButtons();
    }

    updateSliderWidth();

    function moveSlider(direction) {
        const moveBy = cardWidth * visibleCards;

        if (direction === 'next' && currentIndex < maxIndex) {
            currentIndex++;
            scrollPosition -= moveBy;
        } else if (direction === 'prev' && currentIndex > 0) {
            currentIndex--;
            scrollPosition += moveBy;
        }

        wrapper.style.transition = 'transform 1s ease';
        wrapper.style.transform = `translateX(${scrollPosition}px)`;

        updateButtons();
    }

    nextBtn.addEventListener('click', () => moveSlider('next'));
    prevBtn.addEventListener('click', () => moveSlider('prev'));

    window.addEventListener('resize', updateSliderWidth);
})();
